import { useCallback } from 'react';
import useDisclaimerTabs from '../../../hooks/useDisclaimerTabs';

/**
 * Hook to handle footer link click by settting disclaimer tab
 * @typedef {Object} useFooterLink
 */
export default (tab = 'product', target = 'footerLink') => {
    const [, setDisclaimerTab] = useDisclaimerTabs();
    const interceptClick = useCallback(
        ev => {
            if (ev.target.classList.contains(target)) {
                setDisclaimerTab(tab);
            }
        },
        [tab, target],
    );

    return { interceptClick };
};
